import { Session, TaasCard, Review } from "../TalentDashboardInterface/TalentDashboardInterface";
import { useMemo } from "react";
import {
    TrendingUp,
    Visibility,
    ThumbUpAlt,
    CalendarMonth,
  } from "@mui/icons-material";
  
export const dummySessions: Session[] = [
  {
    id: "sess1",
    time: "10:00 AM - 11:00 AM",
    serviceName: "1:1 Acting Workshop",
    talentName: "John Doe",
    joinLink: "https://example.com/session/1",
  },
  {
    id: "sess2",
    time: "2:00 PM - 3:00 PM",
    serviceName: "Dance Coaching: Hip-Hop",
    talentName: "Jane Lee",
    joinLink: "https://example.com/session/2",
  },
];

export const dummyTaasCards: TaasCard[] = [
    {
      id: "card1",
      title: "1:1 Music Coaching",
      image: "https://source.unsplash.com/random/300x200?music",
      isActive: true,
      description: "Live session for vocal training",
    },
    {
      id: "card2",
      title: "Creative Writing Workshop",
      image: "https://source.unsplash.com/random/300x200?writing",
      isActive: false,
      description: "Learn how to write with impact",
    },
  ];
  
  export const dummyReviews: Review[] = [
    {
      id: "1",
      reviewerName: "Alice Park",
      reviewerAvatar: "https://i.pravatar.cc/150?img=3",
      rating: 4.5,
      comment: "Fantastic experience! Highly recommend.",
      createdAt: "2025-04-08T14:22:00Z",
      cardTitle: "Guitar Lessons",
    },
    {
      id: "2",
      reviewerName: "John Doe",
      reviewerAvatar: "https://i.pravatar.cc/150?img=6",
      rating: 5,
      comment: "Very friendly and talented!",
      createdAt: "2025-04-07T10:10:00Z",
    },
  ];

  export const dummyData ={ 
    sessions: [
      { id: "1", title: "Dance Session", time: "2:00 PM" },
      { id: "2", title: "Voice Coaching", time: "4:00 PM" },
    ],
    cards: [
      { id: "101", title: "Hip-Hop Beginner", active: true },
      { id: "102", title: "Jazz Vocals", active: false },
    ],
    wallet: { balance: 1200, weeklyEarnings: 350, withdrawalsPending: false },
    reviews: [
      { id: "1", user: "Alex", rating: 4, comment: "Great experience!" },
      { id: "2", user: "Taylor", rating: 5, comment: "Loved the session!" },
    ],
    performance: {
      bookedSessions: 8,
      earnings: 600,
      topSuit: "Dance",
    },
    isAvailable: true,
  };



  
export const mockSnapshotData = [
    {
      label: "Total Views",
      value: 1243,
      icon: <Visibility />,
    },
    {
      label: "Bookings",
      value: 87,
      icon: <CalendarMonth />,
    },
    {
      label: "Card Likes",
      value: 230,
      icon: <ThumbUpAlt />,
    },
    {
      label: "Growth % (30d)",
      value: "12.8%",
      icon: <TrendingUp />,
      color: "#22C55E", // green
    },
  ]